/**
 * La fenêtre modale du module Facturation.
 *
 * Extraite de FacturationPage le 27/08 : trois écrans du lot H en ont besoin (nouvelle
 * facture, aperçu, coordonnées de facturation) et recopier trois fois le même calque
 * garantissait qu'ils finiraient par se comporter différemment.
 *
 * `taille` décide de la largeur : l'aperçu d'un PDF a besoin de toute la page, un
 * formulaire de coordonnées non.
 */
import { X } from 'lucide-react';

const LARGEURS = {
  formulaire: 'max-w-2xl',
  large: 'max-w-3xl',
  document: 'max-w-5xl',
};

export default function Modale({ titre, icone: Icone, taille = 'formulaire', onClose, children, pied }) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="modale-facturation"
    >
      <div
        className={`bg-white rounded-lg w-full ${LARGEURS[taille]} max-h-[92vh] flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-neutral-100">
          <h2 className="text-lg font-semibold flex items-center gap-2 text-neutral-900">
            {Icone && <Icone className="w-5 h-5 text-neutral-400" />}
            {titre}
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-neutral-100 text-neutral-400 hover:text-neutral-700"
            title="Fermer"
            data-testid="modale-fermer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">{children}</div>

        {pied && (
          <div className="flex justify-end gap-2 px-5 py-3 border-t border-neutral-100">{pied}</div>
        )}
      </div>
    </div>
  );
}
